import { render, staticRenderFns } from "./Ringtones.vue?vue&type=template&id=5c467e6f&scoped=true&"
import script from "./Ringtones.vue?vue&type=script&lang=js&"
export * from "./Ringtones.vue?vue&type=script&lang=js&"
import style0 from "./Ringtones.vue?vue&type=style&index=0&id=5c467e6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c467e6f",
  null
  
)

export default component.exports